import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useApp } from "@/context/AppContext";
import { ClientProjects } from "@/pages/client/ClientProjects";
import { Projects } from "@/pages/team/Projects";

/**
 * `?kunde=` filtert die Team-Liste auf einen Kunden — so verlinkt der
 * Kundenstamm hierher. `?ansicht=board` zeigt seit dem Rundgang vom
 * 12.09.2026 das Produktions-Kanban (vorher die eigene Seite /produktionen).
 * Beide Werte kommen aus der Adresszeile, deshalb zod.
 */
const suchSchema = z.object({
	kunde: z.string().optional(),
	ansicht: z.enum(["liste", "board"]).optional(),
});

export const Route = createFileRoute("/_angemeldet/projekte/")({
	validateSearch: suchSchema,
	component: ProjekteSeite,
});

function ProjekteSeite() {
	const { role } = useApp();
	const { kunde, ansicht } = Route.useSearch();
	const navigate = useNavigate();

	if (role !== "mitarbeiter") {
		return <ClientProjects />;
	}

	return (
		<Projects
			kunde={kunde ?? null}
			ansicht={ansicht ?? "liste"}
			onAnsicht={(neu) => {
				void navigate({
					to: "/projekte",
					search: neu === "board" ? { ansicht: "board" } : {},
					replace: true,
				});
			}}
			onKundeEntfernen={() => {
				void navigate({ to: "/projekte", search: {}, replace: true });
			}}
		/>
	);
}
